import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { deleteExpressParams, getExpressParams } from '../../../service/api';
import ReportManagerMain from '../../presentation/section/report-manager-page/ReportManagerMain';
import JSONtoReportData from '../json-to-chartdata/JSONtoReportData';
import LoadingOverlay from 'react-loading-overlay';
import { REPORT_TYPE_SET } from '../../../config/ReportOptionSet';
import { Channel_CODE_SET } from '../../../config/CgmCodeSet';
import AlertModal from '../../presentation/modal/AlertModal';

const ReportManager = (props) => {
  const [selectedReport, setSelectedReport] = useState({
    reportID: null,
    content: null,
    name: null,
    subQueryType: null,
    reportType: null,
    label: null
  });

  const [selectedReportQuery, setSelectedReportQuery] = useState({
    mainQuery: null,
    subQuery: []
  })

  const [reportLabelData, setReportLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null,
  });

  const [reportFilter, setReportFilter] = useState('');
  
  const [filteredArray, setFilteredArray] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  })

  const [queryData, setQueryData] = useState(null)

  const [resultData, setResultData] = useState(null)

  const [options, setOptions] = useState({
    timeunit: 'daily',
    datatype: 'numeric',
    rows: '50',
    words: '200',
    morph: 'all',
  });
  
  const [loaded, setLoaded] = useState(true);
  const [loadingText, setLoadingText] = useState(<div>loading</div>);
  const [userRole, setUserRole] = useState('');

  const [alertShow, setAlertShow] = useState(false);
  const handleAlertShow = () => setAlertShow(true);
  const handleAlertClose = () => setAlertShow(false);

  useEffect(()=>{
    getExpressParams('/query/report-label/userid/all', {
      email: props.currentUser
    }, (response)=>{
      setReportLabelData(MakeLabelTreeData(response.data.reportentity, response.data.BuzzLabel))
      setQueryData (response.data.queryentity);
    })

    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })
  },[])

  useEffect(()=>{
    handleSearchBtn(JSON.stringify(reportLabelData));
  }, [reportLabelData])

  useEffect(()=>{
    setResultData(null)
  }, [selectedReport])

  const handleSearchBtn = (originArray) => {
    let tempArray = JSON.parse(originArray);
    tempArray.nullLabelItem = tempArray.nullLabelItem.filter((item)=>!reportFilter || item.name.toLowerCase().startsWith(reportFilter.toLowerCase()));

    tempArray.info.forEach(
      (item) => {
        item.labelItem = item.labelItem.filter((reportItem)=> !reportFilter || reportItem.name.toLowerCase().startsWith(reportFilter.toLowerCase()));
      }
    )
    tempArray.info = tempArray.info.filter(
      ((item)=>item.labelItem.length > 0)
    );
    
    setFilteredArray(tempArray);
    setResultData(null);
  }

  const handleSearchInput = (event) => {  
    setReportFilter(event.target.value);
  }

  const handleRunBtn = () => {
    setResultData(null);

    let jsonQueryArray = [];
    jsonQueryArray.push({
      "name": queryData.info.filter(query=>query.queryID===selectedReportQuery.mainQuery)[0].name,
      "type": queryData.info.filter(query=>query.queryID===selectedReportQuery.mainQuery)[0].QUERY_TYPE,
      "content": JSON.parse(queryData.info.filter(query=>query.queryID===selectedReportQuery.mainQuery)[0].content)
    })

    selectedReportQuery.subQuery.forEach((item)=>{
      jsonQueryArray.push({
        "name": queryData.info.filter(query=>query.queryID===item.queryID)[0].name,
        "type": queryData.info.filter(query=>query.queryID===item.queryID)[0].QUERY_TYPE,
        "content": JSON.parse(queryData.info.filter(query=>query.queryID===item.queryID)[0].content)
      })
    })

    setOptions({
      "timeunit": JSON.parse(selectedReport.content).timeunit,
      "datatype": JSON.parse(selectedReport.content).datatype,
      "rows": JSON.parse(selectedReport.content).rows,
      "words": JSON.parse(selectedReport.content).words,
      "morph": JSON.parse(selectedReport.content).morph,
      "buzzRows": JSON.parse(selectedReport.content).buzzRows
    })

    setLoaded(false);
    handleLoadingText();

    getExpressParams(`/report/${selectedReport.REPORT_TYPE}/json`, {
      email: props.currentUser,
      json: {
        "channel": JSON.parse(selectedReport.content).channels,
        "dateRange": JSON.parse(selectedReport.content).date,
        "name": selectedReport.name,
        "query": jsonQueryArray,
        "reportType": selectedReport.REPORT_TYPE,
        "retwit": JSON.parse(selectedReport.content).reTweet,
        "sub_query_type": selectedReport.function,
        "morph": JSON.parse(selectedReport.content).morph
      }
    }, (response) => {
      if(response.data.success){
        setLoaded(true)
        setLoadingText(<div>loadng</div>)
        setResultData(JSONtoReportData(response.data.report_data,
        {
          "timeunit": JSON.parse(selectedReport.content).timeunit,
          "datatype": JSON.parse(selectedReport.content).datatype,
          "rows": JSON.parse(selectedReport.content).rows,
          "words": JSON.parse(selectedReport.content).words,
          "morph": JSON.parse(selectedReport.content).morph
        }));
      }
      else{
        setLoaded(true)
        setLoadingText(<div>loadng</div>)
        handleAlertShow();
      }
    })
  }

  const handleRemoveBtn = (reportID) => {
    deleteExpressParams(`/query/report-content/reportid`, {
      email: props.currentUser,
      reportID: reportID
    }, (response) => {
      setReportLabelData({
        type: null,
        name: null,
        info: [],
        nullLabelItem: [],
        nullLabelItemType: null,
      });
      setReportLabelData(MakeLabelTreeData(response.data.reportentity, response.data.BuzzLabel));
      setSelectedReport({
        reportID: null,
        content: null,
        name: null,
        subQueryType: null,
        reportType: null,
        label: null
      })
      setSelectedReportQuery({
        mainQuery: null,
        subQuery: []
      })
      setResultData(null)
    })
  }

  const handleSelectedReport = (reportInfo) => {
    setSelectedReport(reportInfo);
    // setResultData(null)

    getExpressParams('/query/report-content/userid/reportid', {
      email: props.currentUser,
      reportID: reportInfo.reportID
    }, (response) => {
      setSelectedReportQuery({
        mainQuery: response.data.basequery,
        subQuery: response.data.subquery
      })
    })
  }

  const MakeLabelTreeData = (nodeData, labelData) => {
    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type;
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      // item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.label==item.labelID).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          // pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type;
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.label==null).forEach(
      (item)=>{
        let pushItem = item;
        // pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }

  const handleLoadingText = () => {
    let outputBaseQuery = queryData.info.find(item=>item.queryID==selectedReportQuery.mainQuery).name;
    let outputSubQuery = [];
    selectedReportQuery.subQuery.forEach(subQueryItem=>{
      outputSubQuery.push(queryData.info.find(item=>item.queryID==subQueryItem.queryID).name)
    });
    let outputChannel = [];
    JSON.parse(selectedReport.content).channels.forEach(channelItem=>{
      outputChannel.push(Channel_CODE_SET[channelItem])
    })

    setLoadingText(
    <span style={{textAlign: "left"}}>
      <div>
        Date: {`${JSON.parse(selectedReport.content).date[0]} ~ ${JSON.parse(selectedReport.content).date[1]}`}
      </div>
      <div>
        BaseKeyword: {outputBaseQuery}
      </div>
      {outputSubQuery.length != 0 ?
      <>
        <div>
          SubKeyword: {outputSubQuery.map((item,index)=>{
            if (index==outputSubQuery.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)
          })}
        </div>
        <div>
          SubKeywordType: {selectedReport.function=="compare"? "비교" : "교차"}
        </div>
      </>
      :undefined}
      <div>
        Channel: {outputChannel.map((item,index)=>{
            if (index==outputChannel.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)        
        })}
      </div>
      <div>
        Report Type: {REPORT_TYPE_SET[selectedReport.REPORT_TYPE]}
      </div>
    </span>
    )
  }

  return (
    <>
      <AlertModal alertShow={alertShow} handleAlertClose={handleAlertClose} handleAlertShow={handleAlertShow} />
      <LoadingOverlay
        active={!loaded}
        spinner={true}
        text={loadingText}>
          <ReportManagerMain selectedReport={selectedReport} handleSelectedReport={handleSelectedReport} reportLabelData={reportLabelData} handleSearchBtn={handleSearchBtn} reportFilter={reportFilter} handleSearchInput={handleSearchInput} filteredArray={filteredArray}
            queryData={queryData} handleRemoveBtn={handleRemoveBtn} handleRunBtn={handleRunBtn} resultData={resultData} options={options} selectedReportQuery={selectedReportQuery} userRole={userRole}
          />
      </LoadingOverlay>
    </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
});
export default connect(mapStateToProps) (ReportManager);  